const COLUMNS_HEADERS_VALIDATED = {
  /*   collapsable: 'laboratoryNoteSD',
  collapsableColums: {
    supplier: {},
    createdAt: { isDate: true },
  }, */
  docket_number: {
    sortable: true,
    searchable: true,
    ascSort: true,
    integer: true,
  },
  supplier: { sortable: true, searchable: true },
  arriving_date: { sortable: true },
  isLotified: { isVisible: false },
  isAssayed: { isVisible: false },
};

const COLUMNS_HEADERS_NO_VALIDATED = {
  docket_number: {
    sortable: true,
    searchable: true,
    integer: true,
  },
  supplier: { sortable: true, searchable: true },
  model: {
    translatable: true,
    sortable: true,
    filterable: true,
    filterableData: { 1: 'delivery', 2: 'laboratory' },
  },
  createdAt: { isDate: true, sortable: true },
};
const BUTTONS_VALIDATED = {
  viewAction: { tooltip: 'viewAction.record' },
  editAction: { tooltip: 'editAction.record' },
  deleteAction: { tooltip: 'deleteAction.record' },
  eheAction: { tooltip: 'eheAction.record' },
};

const BUTTONS_NO_VALIDATED = {
  editAction: { tooltip: 'editAction.record' },
  deleteAction: { tooltip: 'deleteAction.record' },
};

export {
  COLUMNS_HEADERS_VALIDATED,
  BUTTONS_VALIDATED,
  COLUMNS_HEADERS_NO_VALIDATED,
  BUTTONS_NO_VALIDATED,
};
